import { mergeClassnames } from '@heathmont/moon-core-tw';
import type RtpState from '../helpers/RtpState';
import ArrowsTopRight from '@/external/icons/ArrowsTopRight';

type Props = { state: RtpState; color?: string };

const RtpArrow: FC<Props> = ({ state, color = 'text-goten' }) => (
  <ArrowsTopRight
    className={mergeClassnames(
      'text-[1rem]',
      state === 'cold' && 'rotate-180',
      color,
    )}
  />
);

export default RtpArrow;
